/* Tysk katalog for locale-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'adv.sales.productsShowMore': 'Mehr anzeigen',
  'adv.sales.productsNote': 'Der Betrag unter „Höchster Umsatz“ ist der fakturierte Umsatz je Produkt im gewählten Jahr. Wachstum und Rückgang zeigen die prozentuale Umsatzveränderung desselben Produkts gegenüber dem Vorjahr. Produkte ohne vergleichbare Vorjahreszahlen werden unter Wachstum und Rückgang nicht angezeigt.',
  'adv.sales.productsPage': 'Seite {page} von {pages}',
  'adv.sales.productsPrevious': 'Vorherige Seite für {label}',
  'adv.sales.productsNext': 'Nächste Seite für {label}',
  'adv.sales.scn.adjust.priceUp': 'Preiserhöhung',
  'adv.sales.scn.adjust.volumeDown': 'Rückgang des Absatzvolumens',
  'sale.doc.invoice': 'Neue Rechnung',
  'sale.doc.quote': 'Neues Angebot',
  'sale.doc.orderConfirmation': 'Neue Auftragsbestätigung',
  'sale.doc.creditNote': 'Neue Gutschrift',
  'sale.doc.other': 'Sonstiger Verkauf',
  'sale.howToCreate': 'Wie möchtest du {document} erstellen?',
  'sale.docIndefinite.invoice': 'eine Rechnung',
  'sale.docIndefinite.quote': 'ein Angebot',
  'sale.docIndefinite.orderConfirmation': 'eine Auftragsbestätigung',
  'sale.docIndefinite.creditNote': 'eine Gutschrift',
  'sale.docIndefinite.other': 'einen sonstigen Verkauf',
  'sale.credit.title': 'Gutschrift',
  'sale.credit.help': 'Eine Gutschrift storniert einen Verkauf. Die Beträge werden wie auf einer Rechnung positiv eingegeben — Plumme kehrt das Vorzeichen bei der Buchung um, sodass Umsatzerlöse und Umsatzsteuer reduziert und die Kundenforderung gutgeschrieben wird.',
  'sale.credit.reason': 'Grund der Gutschrift',
  'sale.credit.reasonHint': 'Pflichtfeld. Die Grundlage muss zeigen, was tatsächlich passiert ist, nicht nur den Betrag.',
  'sale.credit.reasonPh': 'Warenrücksendung, Preisnachlass, Fehlfakturierung ...',
  'sale.credit.link': 'Mit Rechnung verknüpfen',
  'sale.credit.linkHint': 'Optional. Bei einer Verknüpfung wird die Rechnungsnummer automatisch übernommen und die Gutschrift mit dem offenen Betrag der Rechnung verrechnet.',
  'sale.credit.linkNone': 'Keine Verknüpfung – freies Guthaben',
  'sale.credit.linkSearchPh': 'Nach Rechnungsnummer, Kunde oder Betrag suchen ...',
  'sale.credit.linkNoMatches': 'Keine Rechnungen entsprechen der Suche',
  'sale.credit.linkShowMore': 'Weitere Rechnungen anzeigen',
  'sale.credit.invoiceOption': 'Rechnung {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Aus der Rechnung ausgewählt',
  'sale.credit.noNumber': 'Ohne Nummer',
  'sale.credit.reference': 'Betrifft (ursprünglicher Verkauf)',
  'sale.credit.referenceHint': 'Pflichtfeld ohne Rechnungsverknüpfung. Gib Rechnungsnummer, Vereinbarung, Zeitraum oder das System an, in dem der Verkauf erfasst war.',
  'sale.credit.referencePh': 'Z. B. Rechnung 1042 oder „Vereinbarung 2025-04“',
  'sale.credit.linkedTo': 'Schreibt Rechnung {document} gut',
  'sale.credit.offsetBadge': 'Wird automatisch verrechnet',
  'sale.credit.freeHint': 'Ohne Verknüpfung bleibt der Betrag als Guthaben des Kunden bestehen. Du kannst ihn mit einer Rechnung verrechnen oder aus der Rechnungsliste zurückzahlen.',
  'sale.credit.date': 'Gutschriftsdatum',
  'sale.credit.numberLabel': 'Gutschrift-Nr.:',
  'sale.credit.amount': 'Gutschriftsbetrag',
  'sale.credit.previewNote': 'Der Betrag wurde gutgeschrieben. Er wird mit offenen Posten verrechnet oder zurückgezahlt.',
  'sale.credit.previewReason': 'Grund:',
  'sale.credit.previewReference': 'Betrifft:',
  'sale.credit.set': 'Details angeben',
  'sale.credit.edit': 'Ändern',
  'sale.credit.missing': 'Grund und Referenz zum ursprünglichen Verkauf müssen angegeben sein, bevor die Gutschrift erstellt werden kann.',
  'sale.credit.noReference': 'Keine Referenz angegeben',
  'sale.credit.freeBadge': 'Freies Guthaben',
  'sale.credit.needReason': 'Gib zuerst den Grund der Gutschrift ein',
  'sale.credit.needReference': 'Verknüpfe eine Rechnung oder gib an, welchen ursprünglichen Verkauf die Gutschrift betrifft',
  'sale.credit.needDetails': 'Gib zuerst einen Grund an und verknüpfe eine Rechnung oder nenne den ursprünglichen Verkauf',
  'sale.credit.create': 'Gutschrift erstellen',
  'sale.det.period': 'Zeitraum',
  'sale.det.subscriptionFrom': 'Abonnement ab',
  'sale.det.subscriptionTo': 'Abonnement bis',
  'sale.det.rentFrom': 'Miete ab',
  'sale.det.rentTo': 'Miete bis',
  'sale.lines.descShortPh': 'Z. B. Beratungsstunde oder Abonnement',
  'sale.from': 'Von',
  'sale.to': 'Bis',
  'sale.use': 'Verwenden',
  'sale.swap': 'Tauschen',
  'sale.show': 'Anzeigen',
  'sale.edit': 'Bearbeiten',
  'sale.download': 'Herunterladen',
  'sale.send': 'Senden',
  'sale.add': 'Hinzufügen',
  'sale.save': 'Speichern',
  'sale.saveChanges': 'Änderungen speichern',
  'sale.thisSale': 'diesen Verkauf',
  'sale.step.kunde': 'Kunde',
  'sale.step.bilag': 'Beleg',
  'sale.step.detaljer': 'Details',
  'sale.step.linjer': 'Positionen',
  'sale.step.forhandsvisning': 'Vorschau',
  'sale.title': 'Verkauf / Rechnung / Angebot',
  'sale.titleHelp': 'Verkauf erfassen, Rechnung, Angebot oder Auftragsbestätigung erstellen',
  'sale.docTypeHelpTitle': 'Dokumenttyp',
  'sale.docTypeHelp': 'Wähle, welche Art von Verkaufsdokument du erstellst. Eine Rechnung ist eine Zahlungsforderung an den Kunden. Ein Angebot ist ein unverbindliches Preisangebot. Eine Auftragsbestätigung bestätigt eine vereinbarte Bestellung. „Sonstiger Verkauf“ wird für Verkäufe außerhalb des Systems verwendet, bei denen du einen Beleg als Nachweis hochlädst.',
  'sale.stepsHelpTitle': 'Die Schritte des Verkaufs',
  'sale.stepsHelp': 'Der Verkauf ist in vier Schritte unterteilt: Kunde, Details, Positionen und Vorschau (bei „Sonstiger Verkauf“: Beleg, Details, Positionen und Vorschau). Tippe auf einen Schritt, um dorthin zu springen. Ein Schritt wird markiert, wenn noch etwas fehlt, bevor das Dokument erstellt werden kann.',
  'sale.viewHelpTitle': 'Ansicht wechseln',
  'sale.viewHelpToOnePage': 'Wechselt vom schrittweisen Ablauf zu einer einzigen Seite, auf der alle Felder gleichzeitig neben einer Live-Vorschau angezeigt werden. Schneller, wenn du das Formular kennst.',
  'sale.viewHelpToSteps': 'Wechselt von der einzelnen Seite zu einem ruhigen schrittweisen Ablauf, in dem du eins nach dem anderen ausfüllst — Kunde, Details, Positionen und Vorschau. Gut, wenn du unterwegs Anleitung möchtest.',
  'sale.toOnePage': 'Zu „Alles auf einer Seite“ wechseln',
  'sale.toSteps': 'Zu „Schritt für Schritt“ wechseln',
  'sale.stepByStep': 'Schritt für Schritt',
  'sale.previewHelpTitle': 'Vorschau',
  'sale.previewHelp': 'Hier siehst du, wie das fertige Dokument für den Kunden aussieht — mit Absender, Kundeninfo, Positionen und Gesamtsumme. Sie wird beim Ausfüllen aktualisiert, damit du alles prüfen kannst, bevor du es erstellst oder sendest.',
  'sale.previewToggleHelp': 'Zeigt oder verbirgt die Live-Vorschau neben dem Formular. Blende sie aus, wenn du mehr Platz für die Felder möchtest.',
  'sale.previewHide': 'Vorschau ausblenden',
  'sale.previewShow': 'Vorschau anzeigen',
  'sale.previewHeading': 'So sieht das Dokument aus',
  'sale.backToVouchers': 'Zurück zu den Transaktionen',
  'sale.resetTitle': 'Formular zurücksetzen und neu beginnen',
  'sale.reset': 'Zurücksetzen',
  'sale.resetDone': 'Das Formular wurde zurückgesetzt',
  'sale.back': 'Zurück',
  'sale.next': 'Weiter',
  'sale.draftSaved': 'Entwurf gespeichert',
  'sale.draftSavedHelp': 'Der Entwurf liegt so in der Rechnungsliste, wie er jetzt ist. Wenn du etwas änderst, kannst du erneut speichern — das aktualisiert denselben Entwurf.',
  'sale.saveDraft': 'Entwurf speichern',
  'sale.saveDraftHelpTitle': 'Entwurf speichern',
  'sale.saveDraftHelp': 'Speichert den Verkauf als Entwurf in der Rechnungsliste, ohne ihn zu senden oder zu erstellen. Du kannst später dort weitermachen, wo du aufgehört hast.',
  'sale.saveDraftHelpLong': 'Speichert den Verkauf als Entwurf in der Rechnungsliste, ohne ihn zu senden oder zu erstellen. Du kannst die Seite bedenkenlos verlassen und später dort weitermachen, wo du aufgehört hast.',
  'sale.saveDraftHelpShort': 'Speichert den Verkauf als Entwurf in der Rechnungsliste, ohne ihn zu senden oder zu erstellen. Du kannst die Seite bedenkenlos verlassen und später weitermachen.',
  'sale.drafts': 'Entwürfe',
  'sale.draftsTitle': 'Begonnene Verkäufe, die du noch nicht erstellt hast',
  'sale.noDrafts': 'Keine Entwürfe',
  'sale.searchDrafts': 'Entwürfe durchsuchen...',
  'sale.deleteDraft': 'Entwurf löschen',
  'sale.deleteDraftTitle': 'Entwurf löschen?',
  'sale.deleteDraftBody': 'Möchtest du den Entwurf für {customer} wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  'sale.det.help': 'Daten, Referenzen und Kommentar für das Dokument. Rechnungsdatum/Fälligkeitsdatum bestimmen, wann die Forderung gilt und fällig wird. „Unsere Referenz“ ist die zuständige Person bei euch, „Ihre Referenz“ ist das Projekt oder die Kontaktperson des Kunden. Bei Rechnungen kannst du außerdem „Wiederkehrend“ aktivieren, damit sie in jeder Periode automatisch versendet wird.',
  'sale.det.date': 'Datum',
  'sale.det.due': 'Fälligkeit',
  'sale.det.ourRef': 'Unsere Referenz',
  'sale.det.ourRefPh': 'Z. B. Sachbearbeiter bei uns',
  'sale.det.theirRef': 'Ihre Referenz',
  'sale.det.theirRefPh': 'Ihre Referenz / Projekt',
  'sale.det.payTo': 'Zahlen an',
  'sale.det.payToHelp': 'Das Bankkonto, auf das der Kunde die Rechnung zahlen soll. Die Liste zeigt deine gespeicherten Bankkonten — das Rechnungskonto aus den Einstellungen ist vorausgewählt, und du kannst direkt hier ein neues Konto hinzufügen.',
  'sale.det.payToDefault': 'Rechnungskonto',
  'sale.det.payToEmpty': 'Kein Bankkonto gespeichert',
  'sale.det.payToAdd': '+ Bankkonto hinzufügen ...',
  'sale.det.comment': 'Kommentar',
  'sale.det.commentPh': 'Optionaler Kommentar, der auf dem Dokument angezeigt wird',
  'sale.det.savedComments': 'Gespeicherte Kommentare',
  'sale.det.saveComment': 'Kommentar speichern',
  'sale.det.useComment': 'Kommentar verwenden',
  'sale.det.noSavedComments': 'Noch keine gespeicherten Kommentare.',
  'sale.det.deliveryFrom': 'Liefer-/Leistungszeitraum - Von',
  'sale.det.deliveryTo': 'Liefer-/Leistungszeitraum - Bis',
  'sale.det.repeating': 'Wiederkehrend',
  'sale.det.repeatingHelpTitle': 'Wiederkehrende Rechnung',
  'sale.det.repeatingHelp': 'Aktiviere diese Option, damit die Rechnung in regelmäßigen Abständen automatisch versendet wird — zum Beispiel monatlich bei einem Abonnement. Du wählst Intervall und Fälligkeit, und Plumme erstellt und versendet jede Periode eine neue Rechnung, ohne dass du etwas tun musst.',
  'sale.det.sentEvery': 'Gesendet jede(n)',
  'sale.period.week': 'Woche',
  'sale.period.month': 'Monat',
  'sale.period.quarter': 'Quartal',
  'sale.period.year': 'Jährlich',
  'sale.det.sameDay': 'Am selben Tag',
  'sale.lines.help': 'Die Waren und Dienstleistungen des Verkaufs. Jede Zeile hat Menge, Preis, MwSt.-Satz und ggf. Rabatt, und die Zeilensumme wird automatisch berechnet. Wähle ein gespeichertes Produkt oder schreibe Freitext und ziehe am Griff links, um die Reihenfolge zu ändern.',
  'sale.lines.add': 'Zeile hinzufügen',
  'sale.lines.product': 'Produkt',
  'sale.lines.productPh': 'Suchen oder neues Produkt eingeben...',
  'sale.lines.noProductMatch': 'Keine gespeicherten Produkte gefunden',
  'sale.lines.editProduct': 'Produkt bearbeiten',
  'sale.lines.productName': 'Produktname',
  'sale.lines.description': 'Beschreibung',
  'sale.lines.descriptionPh': 'Optionale Beschreibung des Produkts/der Zeile',
  'sale.lines.qty': 'Menge',
  'sale.lines.vat': 'MwSt.',
  'sale.lines.discount': 'Rabatt',
  'sale.lines.netSum': 'Zeilensumme ohne MwSt.',
  'sale.lines.toggleVat': 'Zwischen netto und brutto wechseln',
  'sale.lines.more': 'Mehr',
  'sale.lines.less': 'Weniger',
  'sale.lines.searchAccount': 'Konto suchen...',
  'sale.lines.noAccountMatch': 'Keine Konten entsprechen der Suche.',
  'sale.lines.pickAccount': 'Konto wählen',
  'sale.lines.searchProductPh': 'Nach Name oder Beschreibung suchen...',
  'sale.sum.help': 'Die Summe für den gesamten Verkauf: Betrag ohne MwSt. plus MwSt. ergibt den Betrag, den der Kunde zahlt. Die Zahlen werden automatisch aktualisiert, wenn du die Zeilen änderst.',
  'sale.att.title': 'Anhänge',
  'sale.att.upload': 'Anhang hochladen',
  'sale.att.drop': 'Dateien hierher ziehen',
  'sale.att.dropHint': 'Bilder oder PDF, oder einfügen',
  'sale.att.pickFile': 'Datei wählen',
  'sale.att.dropToAdd': 'Anhang ablegen, um ihn hinzuzufügen',
  'sale.att.dragTip': 'Tipp: Du kannst Dateien auch direkt auf die Seite ziehen.',
  'sale.att.forgot': 'Einen Beleg vergessen? Lege ihn hier ab',
  'sale.att.fromInbox': 'Aus dem Posteingang holen',
  'sale.att.uploadInstead': 'Stattdessen Beleg hochladen',
  'sale.att.view': 'Beleg ansehen',
  'sale.att.openPreview': 'In der Vorschau öffnen',
  'sale.send.title': 'Dokument wird gesendet',
  'sale.send.to': 'Senden an',
  'sale.send.replyTo': 'Antwort an',
  'sale.send.asPdf': 'Als PDF-Anhang senden',
  'sale.send.asLink': 'Als Link senden',
  'sale.send.pdfHint': 'Der Kunde erhält das Dokument direkt in der E-Mail.',
  'sale.send.linkHint': 'Liefert eine Lesebestätigung, wenn der Kunde das Dokument öffnet.',
  'sale.send.how': 'Wie soll das Dokument versendet werden?',
  'sale.send.newRecipient': 'Neue E-Mail-Adresse …',
  'sale.send.saveContact': 'Als Kontaktperson bei {customer} speichern',
  'sale.send.thisCustomer': 'dem Kunden',
  'sale.send.contactName': 'Name',
  'sale.send.contactNamePh': 'Max Mustermann',
  'sale.send.contactRole': 'Rolle',
  'sale.send.contactRolePh': 'Buchhaltung',
  'sale.send.contactSaveFailed': 'Das Dokument wurde gesendet, aber die Kontaktperson konnte nicht gespeichert werden.',
  'sale.send.emailPh': 'name@example.com',
  'sale.send.viewDocument': 'Dokument ansehen',
  'sale.preview.sender': 'Absender:',
  'sale.preview.invoiceNo': 'Rechnungsnr.:',
  'sale.preview.invoiceDate': 'Rechnungsdatum:',
  'sale.preview.dueDate': 'Fälligkeitsdatum:',
  'sale.preview.ourRef': 'Unsere Referenz:',
  'sale.preview.theirRef': 'Ihre Referenz:',
  'sale.preview.comment': 'Kommentar:',
  'sale.preview.accountNo': 'Kontonr.:',
  'sale.preview.toPay': 'Zu zahlen:',
  'sale.preview.net': 'Netto',
  'sale.preview.vat': 'MwSt.',
  'sale.preview.paid': 'Bezahlt',
  'sale.preview.toPayShort': 'Zu zahlen',
  'sale.preview.receipt': 'Quittung',
  'sale.preview.paymentHint': 'Bitte gib bei der Zahlung die Rechnungsnummer an',
  'sale.preview.currencyNote': 'Alle Beträge sind in {currency} angegeben',
  'sale.lines.fromDraftDescr': 'Aus Entwurf übernommen',
  'sale.att.maxSize': 'Anhänge dürfen höchstens {max} groß sein.',
  'sale.att.addedOne': '1 Anhang hinzugefügt',
  'sale.att.addedMany': '{count} Anhänge hinzugefügt',
  'sale.comment.deleted': 'Kommentar gelöscht',
  'sale.comment.deleteFailed': 'Der Kommentar konnte nicht gelöscht werden.',
  'sale.comment.writeFirst': 'Schreibe zuerst einen Kommentar',
  'sale.comment.updated': 'Kommentar aktualisiert',
  'sale.comment.saveFailed': 'Der Kommentar konnte nicht gespeichert werden.',
  'sale.comment.alreadySaved': 'Der Kommentar ist bereits gespeichert',
  'sale.comment.saved': 'Kommentar gespeichert',
  'sale.comment.backendUnavailable': 'Kommentare sind nicht mit dem Backend verbunden.',
  'sale.det.offerDate': 'Angebotsdatum',
  'sale.det.orderDate': 'Auftragsdatum',
  'sale.det.saleDate': 'Verkaufsdatum',
  'sale.det.invoiceDateLabel': 'Rechnungsdatum',
  'sale.det.validUntil': 'Gültig bis',
  'sale.det.dueDateLabel': 'Fälligkeitsdatum',
  'sale.textLine.titleUpdate': 'Textzeile aktualisieren',
  'sale.textLine.titleNewHeading': 'Neue Überschrift',
  'sale.textLine.titleNewText': 'Neue Textzeile',
  'sale.textLine.update': 'Aktualisieren',
  'sale.textLine.typeLabel': 'Typ',
  'sale.textLine.typeText': 'Textzeile',
  'sale.textLine.typeHeading': 'Überschrift',
  'sale.textLine.nameLabel': 'Name',
  'sale.textLine.namePhHeading': 'Z. B. Arbeit',
  'sale.textLine.namePhText': 'Z. B. Produkt X',
  'sale.textLine.textLabel': 'Text',
  'sale.textLine.textPh': 'Optionaler Text, der unter der Zeile angezeigt wird',
  'sale.textLine.styleFor': 'Stil für {target}',
  'sale.textLine.boldShort': 'F',
  'sale.textLine.italicShort': 'K',
  'sale.textLine.useDivider': 'Trennlinie verwenden',
  'sale.textLine.dividerHint': 'Linie unter dem Text im Dokument anzeigen.',
  'sale.textLine.searchPhHeading': 'Überschrift suchen oder eingeben...',
  'sale.textLine.searchPhText': 'Textzeile suchen oder eingeben...',
  'sale.textLine.noMatch': 'Keine gespeicherten Textzeilen gefunden',
  'sale.textLine.addAsHeading': '„{value}“ als neue Überschrift hinzufügen',
  'sale.textLine.addAsText': '„{value}“ als neue Textzeile hinzufügen',
  'sale.textLine.headingSaved': 'Überschrift gespeichert',
  'sale.textLine.textSaved': 'Textzeile gespeichert',
  'sale.textLine.headingAdded': 'Überschrift hinzugefügt',
  'sale.textLine.textAdded': 'Textzeile hinzugefügt',
  'sale.textLine.saveFailed': 'Die Textzeile konnte nicht gespeichert werden.',
  'sale.det.durationMonth1': '1 Monat',
  'sale.det.durationMonth3': '3 Monate',
  'sale.det.durationMonth6': '6 Monate',
  'sale.det.durationMonth12': '12 Monate',
  'sale.lines.typeProduct': 'Produktzeile',
  'sale.lines.typeSpacer': 'Leerzeile',
  'sale.lines.noText': 'Ohne Text',
  'sale.lines.qtyUnit': '{qty} Stk.',
  'sale.preview.receiptNoLabel': 'Quittungsnr.:',
  'sale.preview.quoteNoLabel': 'Angebotsnr.:',
  'sale.preview.orderNoLabel': 'Auftragsnr.:',
  'sale.preview.backToOther': 'Zurück zu Sonstiger Verkauf',
  'sale.preview.backToInvoice': 'Zurück zur Rechnung',
  'sale.preview.vatMoms': 'MwSt.',
  'sale.preview.continuesNextPage': 'Fortsetzung auf der nächsten Seite',
  'sale.att.labelWithName': 'Anhang · {name}',
  'sale.att.dropHere': 'Beleg hier ablegen',
  'sale.att.otherSaleHint': 'Sonstiger Verkauf ist für allgemeine Verkäufe außerhalb des Systems - lade ein Bild oder PDF als Nachweis hoch.',
  'sale.att.previewHint': 'Für die Vorschau tippe auf einen deiner Anhänge oder auf „Quittung ansehen“.',
  'sale.att.viewReceipt': 'Quittung ansehen',
  'sale.att.createReceipt': 'Quittung erstellen',
  'sale.mode.subtitle': 'Wähle einen ruhigen, schrittweisen Ablauf oder behalte alle Felder auf einer Seite.',
  'sale.mode.stepsDesc': 'Kunde, Details, Zeilen und Vorschau - eins nach dem anderen. Gut für Einsteiger.',
  'sale.mode.onePageDesc': 'Die ganze Rechnung auf einen Blick mit Live-Vorschau. Schnell für Erfahrene.',
  'sale.draft.noCustomer': 'Ohne Kunde',
  'sale.draft.noMatchesTitle': 'Keine Treffer',
  'sale.draft.noMatchesText': 'Keine Entwürfe entsprechen der Suche.',
  'sale.draft.emptyText': 'Begonnene Verkäufe werden hier gespeichert, wenn du auf „Entwurf speichern“ tippst.',
  'sale.draft.colSale': 'Verkauf',
  'sale.draft.noNumber': 'Ohne Nummer',
  'sale.draft.colDate': 'Datum',
  'sale.draft.colAmount': 'Betrag',
  'sale.draft.deleteFailed': 'Der Entwurf konnte nicht gelöscht werden.',
  'sale.draft.saveFailed': 'Der Entwurf konnte nicht gespeichert werden.',
  'sale.draft.deleteUnavailable': 'Das Löschen von Entwürfen ist nicht mit dem Backend verbunden.',
  'sale.draft.onlyDraftsDelete': 'Hier können nur Entwürfe gelöscht werden',
  'sale.draft.deleted': 'Entwurf gelöscht',
  'sale.draft.saveUnavailable': 'Das Speichern von Entwürfen ist nicht mit dem Backend verbunden.',
  'sale.draft.savedToList': 'Der Entwurf wurde in der Rechnungsliste gespeichert',
  'sale.create.invoice': 'Rechnung erstellen',
  'sale.create.quote': 'Angebot erstellen',
  'sale.create.order': 'Auftragsbestätigung erstellen',
  'sale.create.other': 'Verkauf erfassen',
  'sale.create.needMatchingPartials': 'Die Summe der Teilzahlungen muss zuerst mit dem Verkaufsbetrag übereinstimmen',
  'sale.create.needLineOrAttachment': 'Füge zuerst eine Zeile oder einen Beleg hinzu',
  'sale.create.needCustomerAndProduct': 'Wähle zuerst einen Kunden und füge mindestens ein Produkt hinzu',
  'sale.create.needCustomer': 'Wähle zuerst einen Kunden',
  'sale.create.needProduct': 'Füge zuerst mindestens ein Produkt hinzu',
  'sale.create.receiptSendingBackground': 'Die Quittung wird im Hintergrund gesendet',
  'sale.create.receiptSentEmail': 'Die Quittung wurde per E-Mail gesendet.',
  'sale.create.recurringSaveFailed': 'Die Rechnung wurde erstellt, aber die wiederkehrende Vereinbarung konnte nicht gespeichert werden.',
  'sale.create.createFailed': 'Der Verkauf konnte nicht erstellt werden.',
  'sale.create.createdTitle': '{doc} {num} wurde erstellt.',
  'sale.create.saleCreatedBody': 'Der Verkauf wurde gebucht. Du kannst die Quittung speichern, dem Kunden die Dokumentation senden oder schließen.',
  'sale.create.docCreatedBody': 'Du kannst {def} als PDF speichern oder {pron} per E-Mail weitersenden.',
  'sale.create.pdfReceiptLabel': 'PDF/Quittung',
  'sale.create.pdfLabel': 'PDF',
  'sale.send.unavailableSale': 'Das Senden ist für diesen Verkauf nicht verfügbar.',
  'sale.send.unavailableDocument': 'Das Senden ist für dieses Dokument nicht verfügbar.',
  'sale.send.failed': 'Das Senden ist fehlgeschlagen.',
  'sale.send.customerFallback': 'Kunde',
  'sale.send.defaultContactRole': 'Standardkontakt',
  'sale.send.contactFallback': 'Ansprechpartner',
  'sale.send.recipientFallback': 'Empfänger',
  'sale.send.receiptTitle': 'Quittung senden',
  'sale.send.howToSend': 'Wie möchtest du {doc} senden?',
  'sale.send.receiptEmailHint': 'Gib die E-Mail-Adresse ein, an die die Quittung gesendet werden soll.',
  'sale.send.chooseDeliveryHint': 'Wähle, ob der Kunde ein PDF in der E-Mail erhält oder einen Link, den Postplumma verfolgen kann.',
  'sale.send.allCustomersInList': 'Alle Kunden in der Liste ({count})',
  'sale.send.needEmailFirst': 'Hinterlege vor dem Senden eine E-Mail-Adresse beim Kunden oder einem Ansprechpartner.',
  'sale.send.stepDraftPrep': 'Entwurf wird vorbereitet',
  'sale.send.stepArriving': 'Postplumma kommt an',
  'sale.send.stepSuccess': 'Erfolg! Postplumma ist unterwegs.',
  'sale.send.receiptReadyNoEmail': 'Die Quittung ist bereit, aber es wurde keine E-Mail gesendet.',
  'sale.send.sendingInBackground': '{doc} wird im Hintergrund gesendet',
  'sale.send.sentAsLinkShort': '{doc} wurde als Link gesendet.',
  'sale.send.sentAsLinkTracked': '{doc} wurde als Link gesendet. Den Lesestatus kannst du in der Rechnungsliste verfolgen.',
  'sale.send.sentAsEmail': '{doc} wurde per E-Mail gesendet.',
  'sale.send.readyNoEmail': '{doc} ist bereit, aber es wurde keine E-Mail gesendet.',
  'sale.send.sentToRecipients': 'An {count} Empfänger gesendet.',
  'sale.send.notProvided': 'Nicht angegeben',
  'sale.send.spamTip': 'Tipp: Wenn der Kunde die E-Mail nicht findet, bitte ihn, im Spam-Ordner nachzusehen.',
  'sale.inboxPicker.tabInbox': 'Posteingang ({count})',
  'sale.inboxPicker.tabDocumentation': 'Dokumentation ({count})',
  'sale.inboxPicker.searchDocumentation': 'In der Dokumentation suchen',
  'sale.inboxPicker.searchInbox': 'Im Posteingang suchen',
  'sale.inboxPicker.selectTip': 'Tipp: Halte Shift gedrückt, um mehrere hintereinander auszuwählen, oder Ctrl/Cmd, um einzeln auszuwählen.',
  'sale.inboxPicker.emptyDocumentation': 'Keine Dokumente entsprechen der Suche.',
  'sale.inboxPicker.emptyInbox': 'Keine Belege im Posteingang entsprechen der Suche.',
  'sale.inboxPicker.fallbackReceipt': 'Beleg',
  'sale.inboxPicker.fallbackDocument': 'Dokument',
  'sale.inboxPicker.fallbackDocumentation': 'Dokumentation',
  'sale.lines.subscriptionPeriod': 'Abonnement - {{period}}',
  'sale.lines.months12': '12 Mon.',
  'sale.lines.month1': '1 Mon.',
  'sale.lines.rentalPrice': 'Vermietung - {{price}}',
  'sale.lines.addAsNewProduct': '„{{value}}“ als neues Produkt hinzufügen',
  'sale.lines.useDivider': 'Trennlinie verwenden',
  'sale.lines.dividerHint': 'Zeigt im Dokument eine Linie unter dieser Zeile.',
  'sale.preview.colDescription': 'Beschreibung',
  'sale.preview.colQty': 'Menge',
  'sale.preview.colPrice': 'Preis',
  'sale.preview.colDiscount': 'Rabatt',
  'sale.preview.colSum': 'Summe',
  'sale.doc.invoiceName': 'Rechnung',
  'sale.doc.quoteName': 'Angebot',
  'sale.doc.orderConfirmationName': 'Auftragsbestätigung',
  'sale.doc.creditNoteName': 'Gutschrift',
  'sale.draft.colType': 'Typ',
  'sale.period.every14days': 'Alle 14 Tage',
  'sale.det.dueDays': '{{count}} Tage',
  'sale.lines.priceExVat': 'Preis ohne MwSt.',
  'sale.lines.priceIncVat': 'Preis inkl. MwSt.',
  'sale.lines.lineNumber': 'Zeile {{n}}',
  'sale.lines.pickProduct': 'Produkt wählen',
  'sale.lines.freeText': 'Freitext',
  'sale.lines.spacerHint': 'Eine leere Zeile erscheint im Dokument als Abstand.',
  'sale.lines.chooseLineType': 'Zeilentyp wählen',
  'agreements.notSent': 'Nicht gesendet',
  'agreements.error.missingCustomerEmail': 'Beim Kunden fehlt die E-Mail-Adresse. Hinterlege eine E-Mail beim Kunden, dann wird die Rechnung beim nächsten Lauf gesendet.',
  'agreements.error.missingCustomer': 'Der Kunde existiert nicht mehr oder ist archiviert. Wähle einen aktiven Kunden für die Vereinbarung.',
  'agreements.warning.missingCustomerEmail': 'Beim Kunden fehlt die E-Mail-Adresse',
  'agreements.warning.missingCustomerEmailHelp': 'Der automatische Versand erfordert eine E-Mail-Adresse. Hinterlege sie vor dem nächsten Rechnungsdatum beim Kunden, sonst wird die Rechnung nicht gesendet.',
});
